$(document).ready(() => {
  // ========= GSAP + Lenis Init =========
  const initGsapAndLenis = () => {
    gsap.registerPlugin(ScrollTrigger);

    const lenis = new Lenis();
    window._lenis = lenis;

    lenis.on("scroll", () => ScrollTrigger.update());
    gsap.ticker.add((time) => lenis.raf(time * 1000));
    gsap.ticker.lagSmoothing(100);

    $(window).scrollTop(0);
    ScrollTrigger.refresh();
  };

  // ===== FULLPAGE.JS-LIKE (PIN + WHEEL STEP, STABLE) =====
  const fullPageScrollSlides = () => {
    const $sections = $(".fullPageScrollSlides");
    if (!$sections.length) return;
    if (!window.gsap || !window.ScrollTrigger) return;

    const tlDefaults = { ease: "power2.inOut", duration: 0.9 };

    $sections.each(function (i) {
      const $section = $(this);
      const $container = $section.find(".fullSizeContainer");
      const $slides = $container.find(".fpss-slide");
      if ($slides.length < 2) return;

      // Ensure outer/inner
      $slides.each(function () {
        const $s = $(this);
        if ($s.find(".outer").length) return;
        const $content = $s.children().detach();
        $s.append('<div class="outer"><div class="inner"></div></div>');
        $s.find(".inner").append($content);
      });

      const slides = $slides.toArray();
      const outers = slides.map((s) => s.querySelector(".outer"));
      const inners = slides.map((s) => s.querySelector(".inner"));
      const total = slides.length;

      let currentIndex = 0;
      let animating = false;

      // Layout
      $section.css({
        position: "relative",
        height: "100vh",
        overflow: "hidden",
      });
      $container.css({ position: "relative", height: "100%" });
      $slides.css({ position: "absolute", inset: 0 });

      // Initial state
      gsap.set(slides, { autoAlpha: 0, zIndex: 0 });
      gsap.set(outers, { yPercent: 100 });
      gsap.set(inners, { yPercent: -100 });

      gsap.set(slides[0], { autoAlpha: 1, zIndex: 1 });
      gsap.set([outers[0], inners[0]], { yPercent: 0 });

      const animateTo = (next) => {
        if (animating || next === currentIndex) return;
        animating = true;

        const dir = next > currentIndex ? "down" : "up";

        gsap.set(slides[next], { autoAlpha: 1, zIndex: 2 });
        gsap.set(outers[next], { yPercent: dir === "down" ? 100 : -100 });
        gsap.set(inners[next], { yPercent: dir === "down" ? -100 : 100 });

        gsap
          .timeline({
            defaults: tlDefaults,
            onComplete: () => {
              gsap.set(slides[currentIndex], { autoAlpha: 0, zIndex: 0 });
              gsap.set(slides[next], { zIndex: 1 });

              gsap.set(outers[currentIndex], { yPercent: 100 });
              gsap.set(inners[currentIndex], { yPercent: -100 });

              currentIndex = next;
              animating = false;
            },
          })
          .to([outers[next], inners[next]], { yPercent: 0 }, 0)
          .to(
            outers[currentIndex],
            { yPercent: dir === "down" ? -100 : 100 },
            0
          )
          .to(
            inners[currentIndex],
            { yPercent: dir === "down" ? 100 : -100 },
            0
          );
      };

      // ✅ Create ScrollTrigger and keep reference
      const st = ScrollTrigger.create({
        trigger: $section[0],
        start: "top top",
        end: () => `+=${window.innerHeight * (total - 1)}`,
        pin: true,
        pinSpacing: true,
        scrub: true,
        anticipatePin: 1,
        invalidateOnRefresh: true,
        onUpdate: (self) => {
          const idx = Math.round(self.progress * (total - 1));
          animateTo(idx);
        },
      });

      // ✅ Arrow click -> scroll to next progress step
      const scrollToIndex = (idx) => {
        idx = Math.max(0, Math.min(total - 1, idx));

        // convert slide index -> progress -> scroll position
        const progress = idx / (total - 1);
        const targetY = st.start + progress * (st.end - st.start);

        // If Lenis exists, use it (smoother + correct with your setup)
        if (window._lenis && typeof window._lenis.scrollTo === "function") {
          window._lenis.scrollTo(targetY, { immediate: false });
        } else {
          window.scrollTo({ top: targetY, behavior: "smooth" });
        }
      };

      $section
        .find(".moveToNextImg")
        .off(`click.fpss-${i}`)
        .on(`click.fpss-${i}`, function (e) {
          e.preventDefault();
          e.stopPropagation();
          scrollToIndex(currentIndex + 1);
        });

      // Optional: allow Enter key on arrow span
      $section
        .find(".moveToNextImg")
        .off(`keydown.fpss-${i}`)
        .on(`keydown.fpss-${i}`, function (e) {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            scrollToIndex(currentIndex + 1);
          }
        });
    });

    ScrollTrigger.refresh();
  };

  // ====MOBILE MENU EVENTS====
  const mobieMenuEvents = () => {
    $(document).on("click", "button.mobileMenuOpener", function () {
      $("body, html").addClass("hideScroll mobileMenuIsOpen");
    });
    $(document).on("click", ".closeMenuBtn", function () {
      $("body, html").removeClass("hideScroll mobileMenuIsOpen");
    });
  };


   $(document).on("click", ".swatch__option", function () {
    const $this = $(this);
    const thumbnailContainer = $this.closest('.product__thumbnail');
    const variantSelector = $this.closest('.variant-selection');

    const prodId = $this.data("prodid");
    const dataSwatchId = $this.attr("data-sizeWrapper");

    if ($this.hasClass("isUnstichedItem")) {
      $(dataSwatchId).hide().removeClass("hasSize");
    } else {
      $(dataSwatchId).show().addClass("hasSize");
    }

    setTimeout(() => {
      
      const variantID = variantSelector.attr("variant");
      console.log(`#variantPrice-${prodId}-${variantID}`);
      thumbnailContainer.find(".product-thumbnail__price").hide();
      $(`#variantPrice-${prodId}-${variantID}`).show();
    }, 1000);
  });


    
  // =====AJAX ADD TO CART=====
  const quickATC = () => {
    $(document).on("click", ".add_col_btn", function (e) {
      e.preventDefault();
      const $btn = $(this);
      const formSel = $btn.attr("data-formId");
      const prodId =  $btn.attr("data-product-id");
      const $container = $(formSel);

      if (!$container.length) {
        console.warn("quickATC: container not found for", formSel);
        return;
      }


      // In your theme, variant id is stored on <variant-selection variant="...">
      const variantAttr = $container.attr("variant");

      const variantId = parseInt(variantAttr, 10);

      console.log(`variantAttr ${variantAttr}`);
      console.log(`variantId ${variantId}`);
      if (!variantId || Number.isNaN(variantId) || variantAttr === "not-selected") {
        console.warn("quickATC: invalid variant id", variantAttr);
        return;
      }

      // ---- properties (Size) ----
      // Only include if size UI exists AND is enabled (not hidden/disabled)
      const $sizeBlock = $container.find(".hasSize, [data-stitched-size-wrapper]");
      const properties = {};

      if ($sizeBlock.length && $sizeBlock.is(":visible")) {
        // your product page uses: name="properties[Size]"
        const $checkedSize = $sizeBlock.find('input[name="properties[Size]"]:checked');

        if (!$checkedSize.length) {
          // size compulsory
          // (optional) show message near the button
          $btn.addClass("is-error");
          setTimeout(() => $btn.removeClass("is-error"), 1200);
          alert("Please select a size.");
          return;
        }

        properties["Size"] = $checkedSize.val();
      }

      const originalHtml = $btn.html();
      $btn
        .html(`<span class="button is-loading is-loading--icon-only"></span>`)
        .addClass("focused");

      // Build payload: use properties only when present
      const payload = {
        quantity: 1,
        id: variantId,
      };

      if (Object.keys(properties).length) {
        payload.properties = properties; // Shopify accepts this
        // or payload["properties[Size]"] = properties["Size"];
      }

      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: payload,
        dataType: "json",
        success: function () {
          Shopify.theme.jsAjaxCart.updateView();
          $btn.html(`Added`).removeClass("focused");
          setTimeout(() => {
            $btn.html(originalHtml);
            Shopify.theme.jsAjaxCart.showDrawer();
          }, 1600);
        },
        error: function (xhr) {
          console.error("quickATC add error", xhr);
          $btn.html(originalHtml).removeClass("focused");
        },
      });
    });
  };

  


  // ====CALLING AFTER PAGE LOAD=====
  initGsapAndLenis();
  fullPageScrollSlides();
  mobieMenuEvents();
  quickATC();
});
